// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiline[data-v-fe3394f2]{line-height:18px;font-size:13px;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
